import {
  SET_WS_CONNECTION_ERROR,
  SET_WS_CONNECTION_STATUS,
  SET_WS_DEVICE_STATUS,
} from "./actions";

const initialState = {
  wsOnline: null,
  wsException: null,
  deviceStatusOnline: null,
};

function connectionReducer(state = initialState, action) {
  switch (action.type) {
    case SET_WS_CONNECTION_ERROR:
    case SET_WS_CONNECTION_STATUS:
    case SET_WS_DEVICE_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export { connectionReducer, initialState };
